import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TemoignageAdmin from "../components/composant_Admin/TemoignageAdmin";
import ReservationAdmin from "../components/composant_Admin/ReservationAdmin";
import NewsletterAdmin from "../components/composant_Admin/NewsletterAdmin";
import BulkEmailForm from "../components/composant_Admin/BulkEmailForm";
import "../assets/css/adminmenu.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import logo from "../assets/image/logo1.webp";

const AdminDashboard = () => {
    const { t, i18n } = useTranslation("admin");
    const navigate = useNavigate();
    const location = useLocation();
    const [testimonialCount, setTestimonialCount] = useState(0);
    const [reservationCount, setReservationCount] = useState(0);
    const [subscriberCount, setSubscriberCount] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false); // État pour gérer l'ouverture du menu

    // Créer des références pour chaque section
    const bulkEmailRef = useRef(null);
    const testimonialRef = useRef(null);
    const reservationRef = useRef(null);
    const newsletterRef = useRef(null);
    const API_BASE_URL = process.env.REACT_APP_API_URL;
  
useEffect(() => {
    const fetchCounts = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                return;
            }

            // Récupération du nombre de témoignages
            const testimonialsResponse = await axios.get(
                `${API_BASE_URL}/api/admin/testimonials/count`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setTestimonialCount(testimonialsResponse.data.count || 0);

            // Récupération du nombre de réservations
            const reservationsResponse = await axios.get(
                `${API_BASE_URL}/api/admin/reservations/count`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setReservationCount(reservationsResponse.data.count || 0);

            // Récupération du nombre de newsletters
            const newsletterResponse = await axios.get(
                `${API_BASE_URL}/api/admin/newsletter/count`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setSubscriberCount(newsletterResponse.data.count || 0);
        } catch (error) {
            console.error("Error fetching counts:", error);
        }
    };

    fetchCounts();
}, []);

    // Effect pour gérer le défilement lors du changement de route
    useEffect(() => {
        const handleScroll = () => {
            let targetRef = null;
            switch (location.hash) {
                case "#bulkEmailForm":
                    targetRef = bulkEmailRef;
                    break;
                case "#testimonials":
                    targetRef = testimonialRef;
                    break;
                case "#reservations":
                    targetRef = reservationRef;
                    break;
                case "#newsletter":
                    targetRef = newsletterRef;
                    break;
                default:
                    break;
            }

            if (targetRef && targetRef.current) {
                targetRef.current.scrollIntoView({ behavior: "smooth" });
            }
        };

        handleScroll();
    }, [location.hash]);

    const handleLogout = () => {
        localStorage.removeItem("adminToken");
        navigate("/Connexion");
    };

    const handleLanguageChange = (e) => {
        const newLanguage = e.target.value;
        i18n.changeLanguage(newLanguage);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="admin_dashboard_container">
            <header className="admin_header">
                <div className="admin_header_content">
                    <Link className="admin_logo">
                        <img
                            src={logo}
                            alt={t("logo_alt")}
                            className="admin_logo_image"
                        />
                    </Link>
                    <button className="admin_menu_button" onClick={toggleMenu}>
                        {t("menu")}
                    </button>
                </div>

                <ul className={`admin_nav_list ${isMenuOpen ? "open" : ""}`}>
                    <li className="admin_nav_item">
                        <Link to="#bulkEmailForm" className="admin_nav_link">
                            {t("manage_email")}
                        </Link>
                    </li>
                    <li className="admin_nav_item">
                        <Link to="#testimonials" className="admin_nav_link">
                            {t("manage_testimonials")}
                            <span className="admin_nav_count">
                                {testimonialCount}
                            </span>
                        </Link>
                    </li>
                    <li className="admin_nav_item">
                        <Link to="#reservations" className="admin_nav_link">
                            {t("manage_reservations")}
                            <span className="admin_nav_count">
                                {reservationCount}
                            </span>
                        </Link>
                    </li>
                    <li className="admin_nav_item">
                        <Link to="#newsletter" className="admin_nav_link">
                            {t("manage_newsletter")}
                            <span className="admin_nav_count">
                                {subscriberCount}
                            </span>
                        </Link>
                    </li>
                    <li className="admin_nav_item">
                        <div className="admin_header_actions">
                            <select
                                onChange={handleLanguageChange}
                                defaultValue={i18n.language}
                                className="admin_language_select"
                            >
                                <option value="en">EN</option>
                                <option value="fr">FR</option>
                            </select>
                            <button
                                onClick={handleLogout}
                                className="admin_logout_button"
                            >
                                {t("logout")}
                            </button>
                        </div>
                    </li>
                </ul>
            </header>
            <div className="admin_content">
                <section
                    id="bulkEmailForm"
                    className="admin_section"
                    ref={bulkEmailRef}
                >
                    <BulkEmailForm />
                </section>
                <section
                    id="testimonials"
                    className="admin_section"
                    ref={testimonialRef}
                >
                    <TemoignageAdmin />
                </section>
                <section
                    id="reservations"
                    className="admin_section"
                    ref={reservationRef}
                >
                    <ReservationAdmin />
                </section>
                <section
                    id="newsletter"
                    className="admin_section"
                    ref={newsletterRef}
                >
                    <NewsletterAdmin />
                </section>
            </div>
        </div>
    );
};

export default AdminDashboard;
